<template>
  <div id="choosePurcharseReturn">
    <div class="mask" v-show="mask"></div>
      <div class="invoicingHead" style="height:40px;">
        <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <a @click="jumpTT('/invoicingFather/choosePurcharseGoods')" href="javascript:;">选择退货商品</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>新增进货退货单</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <el-form ref="refundForm" :model="refundForm" label-width="85px">
            <el-form-item label="关联业务单">
              {{orderCode}}
            </el-form-item>
            <el-form-item label="业务日期">
              <el-date-picker style="width:480px;" :clearable="false" v-model="refundForm.dataTime" type="datetime" placeholder="选择业务日期" @change="dataTimeChoose" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
            </el-form-item>
            <el-form-item label="经手人">
                <el-select size="small" v-model="refundForm.shopWorkerUserId" placeholder="经手人" style="width:480px;">
                    <el-option v-for="item in handlerList" :key="item.shopWorkerUserId" :label="item.fullName" :value="item.shopWorkerUserId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商">
                <!-- <el-select size="small" v-model="refundForm.supplierId" placeholder="入库状态" style="width:480px;">
                    <el-option v-for="item in supplierList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId"></el-option>
                </el-select> -->
              {{supplyName}}
            </el-form-item>
            <el-form-item label="入库仓库">
              <!-- <el-select size="small" v-model="refundForm.repositoryId" style="width:480px;">
                <el-option v-for="item in repositoryList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
              </el-select> -->
              {{stockName}}
            </el-form-item>
            <el-form-item label="其他费用">
              <el-input v-model="refundForm.otherFree" @blur="otherFreeBlur"></el-input>
            </el-form-item>
            <el-form-item label="已选商品">
              <div class="flex-start">
                <div style="padding-right: 20px;">
                  <!-- <el-input v-model="refundForm.name" style="width:480px;"></el-input> -->
                  共{{chechedNum}}件商品
                </div>
                <div class="pl20" @click="jumpTT('/invoicingFather/choosePurcharseGoods')">查看详情</div>
              </div>
            </el-form-item>
            <el-form-item label="本单应退">
              <!-- <el-input v-model="refundForm.accountRefundPayable"></el-input> -->
              {{refundMoney ? refundMoney.toFixed(2) : refundMoney}}
            </el-form-item>
            <el-form-item label="图片附加(最多5张)">
              <el-upload
                    action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :http-request="loadImg"
                    :class="{hide:hideUpload}"
                    :on-change="handleEditChange"
                    :limit="5">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
            <el-form-item label="备注信息：">
              <el-input placeholder="输入备注信息" type="textarea" style="width:480px;" v-model="refundForm.refundRemark"></el-input>
            </el-form-item>
            <el-form-item label="结算账户：">
              <!-- <el-input v-model="refundForm.name"></el-input> -->
              现金
            </el-form-item>
            <el-form-item label="实退(元)：">
              <!-- <el-input v-model="refundForm.realityRefundAmount"></el-input> -->
              {{refundMoney ? refundMoney.toFixed(2) : refundMoney}}
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirmSubmit">确认结算</el-button>
            </el-form-item>
      </el-form>
      <!-- 结算成功弹框 -->
      <div class="addSuccess" v-show="addSuccess">
        <div><img src="../../assets/icon/successAdd.png" class="successImg"/></div>
        <div class="mt20 literal1">新增进货退货单成功</div>
        <div class="mt20 literal2">新增进货退货单（{{orderCode}}）完成</div>
        <div class="flex-start mt20">
          <div style="padding-right: 10px; box-sizing:border-box;"><el-button type="primary" plain @click="lookTicks">查看单据</el-button></div>
          <div style="padding-left: 10px; box-sizing:border-box;"><el-button type="primary" @click="finish">完成</el-button></div>
        </div>
      </div>
      <!-- 单据 -->
        <el-dialog
            :visible.sync="voucherDialogVisible"
            width="16%"
            :before-close="handleVoucherClose">
            <span>
               <div class="shopName">{{shopInformation.shopName}}</div>
               <div class="voucherTitle shopName mb20">
                   <span class="line"></span>
                   <span>进货单</span>
                   <span class="lines"></span>
               </div>
               <div class="dottedLine"></div>
               <div class="dottedLine"></div>
               <div class="mt20 mb20">
                   <div class="mb5">入库仓库：{{list.repositoryName}}</div>
                   <div class="mb5">供应商：{{list.supplierName}}</div>
                   <div class="mb5">经手人：{{list.handlerName}}</div>
                   <div class="mb5">单号：{{list.orderCode}}</div>
                   <div>日期：{{list.businessTime}}</div>
               </div>
               <div class="dashedLine mb20"></div>
                   <div class="flex-betweens">
                     <div class="mb5" style="width: 30%;text-align: left">商品</div>
                     <div class="mb5" style="width: 23%;text-align: center">单价</div>
                     <div class="mb5" style="width: 23%;text-align: center">数量</div>
                     <div class="mb5" style="width: 23%;text-align: center">单位</div>
                   </div>
                   <div class="flex-betweens" v-for="(item, index) in voucherList" :key="index">
                     <div class="mb5" style="width: 30%;text-align: left;">{{item.goodsName}}</div>
                     <div style="width: 30%;text-align: center;">{{item.takePrice}}</div>
                     <div style="width: 30%;text-align: center;">{{item.goodsNum}}</div>
                     <div class="mb5" style="width: 30%;text-align: center;">{{item.goodsUnit}}</div>
                   </div>
                   <div class="flex-betweens mb20" >
                    <div>合计</div>
                    <div>￥{{(list.accountRefundPayable - list.otherFree).toFixed(2)}}</div>
                  </div>
               <div class="dashedLine mb20"></div>
               <div class="mt20 mb20">
                   <div class="flex-betweens">
                       <div class="mb5">合计：{{totalLength}}</div>
                       <div class="mb5">￥{{(list.accountRefundPayable - list.otherFree).toFixed(2)}}</div>
                   </div>
                   <div class="mb5">其它费用：￥{{list.otherFree}}</div>
                   <div>结算账户：现金 ￥{{list.accountRefundPayable}}</div>
               </div>
               <div class="dashedLine mb20"></div>
               <div class="mb20">
                   <div class="mb5">应付金额：￥{{list.accountRefundPayable}}</div>
                   <div class="mb5">实付金额：￥{{list.accountRefundPayable}}</div>
                   <div>备注：{{list.refundRemark ? list.refundRemark : "无"}}</div>
               </div>
               <div class="dottedLine"></div>
               <div class="dottedLine"></div>
               <div class="shopName mt20">谢谢惠顾！</div>
            </span>
        </el-dialog>
        <el-dialog
          title=""
          :visible.sync="dialogVisible1"
          width="20%"
          :close-on-click-modal = false
          :before-close="handleClose">
          <span>仓库已被锁定，是否快捷解锁</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="quickLock">确 定</el-button>
          </span>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import { Shop_handlerList, supplierList, uploadImg, saveRefundGoods, repositoryList, singleReturnGoodsList, lockRepository } from '../api';
export default {
    data() {
        return {
          userList: {},
          shopInformation: {},
          refundForm: {
            dataTime: "",
            shopWorkerUserId: "",
            supplierId: "",
            refundRemark: "",
            goodsImages: "",
            otherFree: "",
            accountRefundPayable: "",
            realityRefundAmount: "",
            repositoryId: ""
          },
          goodsImage: "",
          handlerList: [],
          supplierList: [],
          dialogImageUrl: '',
          dialogVisible: false,
          hideUpload: false,
          checkedList: [],
          chechedNum: "",
          lists: [],
          repositoryList: [],
          orderCode: "",
          mask: false,
          addSuccess: false,
          voucherDialogVisible: false,
          list: {
            orderCode: "",
            businessTime: "",
            handlerName: "",
            supplierName: "",
            repositoryName: "",
            otherFree: "",
            accountRefundPayable: "",
            refundRemark: "",
            settlementMethod: "",
            goodsName: "",
            totalTakePrice: "" ,
            takePrice: ""
          },
          voucherList: [],
          totalLength: 0,
          orderCode: "",
          refundMoney: 0,
          dialogVisible1: false,
          originRefundMoney: 0,
          stockName: "",
          stockId: "",
          supplyName: "",
          supplyId: ""
        }
    },
    created() {
        let userList = JSON.parse(this.getCookie("userList"));
        this.userList = userList;
        let shopInformation = JSON.parse(this.getCookie("shopInformation"));
        console.log(shopInformation,userList)
        this.Shop_handlerList()
        console.log(JSON.parse(localStorage.getItem("singlePurchaseAllList") || "[]"))
        this.checkedList = JSON.parse(localStorage.getItem("singlePurchaseAllList") || "[]")
        var res = this.checkedList.filter(function (item,index,arr ) { 
          return item.click == true; 
        }) 
        this.chechedNum = res.length
        console.log(res, "新数组", this.chechedNum)
        res.forEach(item => {
          if (!item.takePrice) {
            item.takePrice = 0
          }
          this.refundMoney += item.goodsNum * item.takePrice
        })
        this.originRefundMoney = this.refundMoney
        var productJson = [];
        res.forEach(function(item){
          productJson.push({goodsId: item.goodsId, productId: item.productId, goodsNum: item.goodsNum}) 
        })
        this.lists = productJson
        console.log(this.lists, productJson)
        this.orderCode = localStorage.getItem("orderCode")
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (month < 9) {
          month = '0' + month
        }
        var dates = date.getDate();
        if (dates < 9) {
          dates = '0' + dates
        }
        var hour = date.getHours();
        if (hour < 9) {
          hour = '0' + hour
        }
        var minutes = date.getMinutes();
        if (minutes < 9) {
          minutes = '0' + minutes
        }
        this.refundForm.dataTime = year + "-" + month + "-" + dates + " " + hour + ":" + minutes; 
    },
    mounted() {
      this.stockName = sessionStorage.stockName
      this.stockId = sessionStorage.stockId
      this.supplyName = sessionStorage.supplyName
      this.supplyId = sessionStorage.supplyId
    },
    methods: {
       handleClose() {
         this.dialogVisible1 = false
       },
       quickLock() {
         lockRepository({
           sessionId: this.userList.sessionId,
           userId: this.userList.id,
           repositoryId: this.refundForm.repositoryId,
           isLock: 0
         })
         .then(res => {
           if (res.code == 1) {
              this.$message.success("解锁成功")
              this.dialogVisible1 = false
              this.confirmSubmit()
           } else {
             this.$message.error(res.msg)
           }
         })
         .catch(error => {
           this.$message.error(error.msg)
         })
       },
        //跳转
        jumpTT(adress, message) {
          this.$router.push({ path: adress, query: { docId: message } });
        },
        // 选择业务日期
        dataTimeChoose() {
          console.log(this.refundForm.dataTime)
        },
        otherFreeBlur(e) {
          if (e.target.value) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || 0
            this.refundMoney = Number(e.target.value) + this.originRefundMoney
          }
        },
        // 经手人列表
        Shop_handlerList() {
            Shop_handlerList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                    this.handlerList = res.data[0].workers
                    this.refundForm.shopWorkerUserId = res.data[0].workers[0].shopWorkerUserId
                    this.getSupplierList()
                }
            })
        },
        // 获取供应商列表
        getSupplierList() {
            supplierList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                  this.supplierList = res.data
                  this.refundForm.supplierId = res.data[0].supplierId
                  this.getRepositoryList()
                }
            })
        },
        // 仓库
        getRepositoryList() {
          repositoryList({
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              isManager: 1,
              isNeedAll: 1,
              pageNo: 1,
              row: 9999,
              shopStoreId: localStorage.getItem("shopStoreId")
          })
          .then(res => {
              console.log(res)  
              if (res.code == 1) {
                this.repositoryList = res.data
                this.refundForm.repositoryId = res.data[0].repositoryId
              }  
          })
        },
        // 移除
        handleRemove(file, fileList) {
            this.hideUpload = fileList.length >= 5
        },
        // 放大
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        // 上传商品图片
        loadImg(res) {
            let imgUploadForm = new FormData();
            imgUploadForm.append("file", res.file);
            imgUploadForm.append("fileContentType", res.file.type);
            imgUploadForm.append("fileFileName", res.file.name);
            imgUploadForm.append("isCompre", 1);
            imgUploadForm.append("isCutImage", 1);
            console.log(imgUploadForm, "imgUploadForm")
            uploadImg(imgUploadForm)
            .then(res => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.refundForm.goodsImages += res.data.data.url + ','
                this.goodsImage = this.refundForm.goodsImages.substring(0, this.refundForm.goodsImages.lastIndexOf(','))
                this.dialogImageUrl = res.data.data.url;
              } else if (res.data.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(res => {}); 
        },
        // 达到最大限制张数，隐藏上传按钮
        handleEditChange (file, fileList) {
          this.hideUpload = fileList.length >= 5
        },
        // 确认结算
        confirmSubmit() {
          saveRefundGoods({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            isManager: 1,
            purchaseId: localStorage.orderId,
            handlerId: this.refundForm.shopWorkerUserId,
            supplierId: this.supplyId,
            otherFree: this.refundForm.otherFree,
            settlementMethod: 1,
            repositoryId: this.stockId,
            accountRefundPayable: this.refundMoney,
            realityRefundAmount: this.refundMoney,
            businessTime: this.refundForm.dataTime,
            refundRemark: this.refundForm.refundRemark,
            photoAppendix: this.goodsImage,
            productJson: JSON.stringify(this.lists)
          })
          .then(res => {
            if (res.code == 1) {
              this.addSuccess = true
              this.mask = true
              this.orderCode = res.data.orderCode
              this.refundForm = {}
              this.totalLength = 0
              this.lists = []
              this.stockName = ""
              this.supplyName = ""
              this.chechedNum = 0
              sessionStorage.removeItem("stockName")
              sessionStorage.removeItem("stockId")
              sessionStorage.removeItem("supplyName")
              sessionStorage.removeItem("supplyId")
              localStorage.removeItem("singlePurchaseAllList")
              localStorage.removeItem("orderId")
              this.refundMoney = 0
              singleReturnGoodsList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 9999,
                orderId: res.data.orderId
              })
              .then(res => {
                if (res.code == 1) {
                  this.list = res.data
                  this.voucherList = res.data.productJson
                  this.voucherList.forEach(element => {
                    this.totalLength += Number(element.goodsNum);
                  });
                }
              })
            } else if (res.code == 26) {
              this.dialogVisible1 = true
            } else {
              this.$message.error(res.msg)
            }
          })
        },
        // 完成
        finish() {
          this.addSuccess = false
          this.mask = false
          this.$router.push("/invoicingFather/chooseGoodsPurchasePrice")
        },
        // 关闭单据  
        handleVoucherClose() {
          this.voucherDialogVisible = false
          this.$router.push("/invoicingFather/chooseGoodsPurchasePrice")
        },
        // 查看单据
        lookTicks() {
          this.voucherDialogVisible = true
          this.addSuccess = false
          this.mask = false
        }
    }
}
</script>

<style scoped>
.literal1 {
  font-size:18px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(85,85,85,1);
}
.literal2 {
  font-size:16px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(153,153,153,1);
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.mt20 {
  margin-top: 20px;
}
.successImg {
  width: 67px;
  height: 67px;
}
.addSuccess {
  width:430px;
  height:311px;
  background:rgba(255, 255, 255, 1);
  z-index: 2;
  position: absolute;
  top: 230px;
  left: 500px;
  border-radius:10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: calc(100vw);
  height: calc(100vh);
  background-color: rgba(101, 101, 101, 0.6);
}
.pl20 {
  color: #349EF4;
  cursor: pointer;
}
.searchGroup {
  position: absolute;
  top: 120px;
  padding-left: 25px;
  box-sizing: border-box;
}
.shopName {
  font-size: 18px;
  text-align: center;
  color: #000;
}
.voucherTitle {
  padding-top: 15px;
  font-size: 18px;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flex-between:last-child {
  text-align: right;
}
.mb5 {
  margin-bottom: 5px
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.dottedLine {
  border: 1px dotted #ccc;
  margin-top: 5px;
}
.dashedLine {
  border: 1px dashed #ccc;
  margin-top: 5px;
}
.line {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  top: 88px;
}
.lines {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  left: 195px;
  top: 88px;
}
</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
}
.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
}
.el-dialog__headerbtn .el-dialog__close {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/choosePurcharseReturn.vue